import { subYears } from 'date-fns';

export const isAdult = (birthDate: Date): boolean => subYears(Date.now(), 18) >= birthDate;

export const isUnderage = (birthDate?: Date): boolean => !!birthDate && !isAdult(birthDate);
